import { booleanAttribute, Component, HostListener, input, output } from '@angular/core';

@Component({
  selector: 'lay-grouped-cta-button',
  templateUrl: './grouped-cta-button.component.html',
  styleUrls: ['./grouped-cta-button.component.scss'],
  host: {
    '[attr.role]': 'role()',
    '[attr.aria-label]': 'ariaLabel()',
    '[attr.aria-disabled]': 'disabled()',
    '[attr.tabindex]': 'disabled() ? -1 : 0',
  }
})
export class GroupedCtaButtonComponent {
  disabled = input(false, { transform: booleanAttribute});
  ariaLabel = input<string>(undefined);
  role = input<string>('button');

  onClick = output<void>();

  @HostListener('click', ['$event'])
  handleClick(event: MouseEvent) {
    if (this.disabled()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    this.onClick.emit();
  }

  @HostListener('keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if ((event.key === 'Enter' || event.key === ' ') && !this.disabled()) {
      event.preventDefault();
      this.onClick.emit();
    }
  }
}
